import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { Fade } from "@progress/kendo-react-animation";
import { Button } from "@progress/kendo-react-buttons";
import { SvgIcon } from "@progress/kendo-react-common";
import { FlatColorPicker, TextBox } from "@progress/kendo-react-inputs";
import { useLocalization } from "@progress/kendo-react-intl";
import { Avatar } from "@progress/kendo-react-layout";
import { NotificationGroup, Notification } from "@progress/kendo-react-notification";
import { copyIcon, plusIcon, saveIcon, trashIcon } from "@progress/kendo-svg-icons";
import axios from "axios";
import { useCallback, useEffect, useRef, useState } from "react";
import { AccessToken } from "../../../config/AccessToken";
import { loadingPanel } from "../../LoadingPanel";
import { Dialog } from "@progress/kendo-react-dialogs";

export const RegistryJobs = () => {

    const localizationService = useLocalization();
    let languageId = localStorage.getItem('languageId');
    const SERVER_URL = process.env.REACT_APP_SERVER_URL;
    const [instance, accessTokenRequest] = AccessToken();

    const userType = localStorage.getItem('userType');

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<any>(false);
    const [errorMessage, setErrorMessage] = useState<any>('');



    const [valueColor, setValueColor] = useState<any>('#ffffff');
    const [jobsList, setJobsList] = useState<any>([]);
    const [jobSearchValue, setJobSearchValue] = useState<string>('');
    const [toggleColorPicker, setToggleColorPicker] = useState<boolean>(false);

    const [messageDeletedJob, setMessageDeletedJob] = useState<boolean>(false);
    const [messageSavedJob, setMessageSavedJob] = useState<boolean>(false);
    const [messageClonedJob, setMessageClonedJob] = useState<boolean>(false);
    const [messageUpdatedJob, setMessageUpdatedJob] = useState<boolean>(false);

    const [jobName, setJobName] = useState<any>('');
    const [updateJob, setUpdateJob] = useState<boolean>(false);
    const [selectedJobId, setSelectedJobId] = useState<any>(null);

    const [jobInfo, setJobInfo] = useState<any>([
        {
            'id': '',
            'name': '',
            'color': '',
            'startDate': new Date()
        }
    ]);

    
    useEffect(() => {
        getJobList(true);
    }, []);

    const hasAppliedDefaultSelectionRef = useRef(false);

    useEffect(() => {
        if (hasAppliedDefaultSelectionRef.current) {
            return;
        }

        if (selectedJobId !== null) {
            hasAppliedDefaultSelectionRef.current = true;
            return;
        }

        if (!Array.isArray(jobsList) || jobsList.length === 0) {
            return;
        }

        hasAppliedDefaultSelectionRef.current = true;
        getSelectedJob(jobsList[0]);
    }, [jobsList, selectedJobId]);

    const getJobList = async (flag: boolean) => {

        setLoading(true);
        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/job/list?enabled=${flag}`, { headers })
                .then((res) => {
                    const data = res?.data?.data

                    let jobList: any = []
                    data.forEach((job: any) => {
                        if(job.id != -1)
                            jobList.push(job)
                    });


                    setJobsList(jobList);
                    setLoading(false);
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                });
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    };

    const rgba2hex = (rgba: any) => {
        return "#" + rgba.replace(/^rgba?\(|\s+|\)$/g, '') // Get's rgba / rgb string values
            .split(',') // splits them at ","
            .filter((string: any, index: any) => index !== 3)
            .map((string: any) => parseFloat(string)) // Converts them to numbers
            .map((number: any, index: any) => index === 3 ? Math.round(number * 255) : number) // Converts alpha to 255 number
            .map((number: any) => number.toString(16)) // Converts numbers to hex
            .map((string: any) => string.length === 1 ? "0" + string : string) // Adds 0 when length of one number is 1
            .join("")
    }

    const handleChangeColor = (event: any) => {
        let color:any = rgba2hex(event.value);
        setValueColor(color);
        setToggleColorPicker(false)
    };

    const showColorPicker = () => {
        setToggleColorPicker(!toggleColorPicker);
    }

    const handleChangeJobName = (event: any) => {
        let currentName:any = event.target.value
        setJobName(currentName)

        if(currentName == ''){
            setJobName([]);
        }else{
            let newGroup: any = [];
            newGroup.push({ 'id': jobInfo[0]?.id, 'name': currentName, 'description': jobInfo[0]?.description, 'color': jobInfo[0]?.color, 'job': jobInfo[0]?.job, 'type': jobInfo[0]?.type })
            setJobInfo(newGroup);
        }
    }

    const getSelectedJob = (job: any) => {
        setSelectedJobId(job.id);
        setJobInfo([{ 'id': job.id, 'name': job.name, 'color': job.color, 'startDate': new Date().toJSON() }]);
        setJobName(job.name);
        setValueColor(job.color);
        setUpdateJob(true)
    }

    const updateSelectedJob = async (jobId: any, jobName: any, jobColor: any) => {

        setLoading(true);

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            
            try {
                await axios.put(`${SERVER_URL}/job/${jobId}/?name=${jobName}&color=${encodeURIComponent(jobColor)}`, null, { headers })
                //setJobName('');
                //handleChangeJobName({ target: { value: '' } })
                //handleChangeColor({ value: '#ffffff' })
                //setValueColor('#ffffff')
                setUpdateJob(false)
                getJobList(true);

                setLoading(false)
                setMessageUpdatedJob(true);
                if (!messageUpdatedJob) {
                    setTimeout(() => {
                        setMessageUpdatedJob(false);
                    }, 3000);
                }

            } catch (error: any) {
                setError(error);
                setErrorMessage(error?.response?.data?.errorMessage)
                setLoading(false)
            }
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }
        
        
    }

    const formatDateFromIsoToString = (isoString:any) => {
        const date = new Date(isoString);
      
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
      
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    }

    const saveNewJob = async (currJobName: any, currValueColor: any) => {

        setLoading(true);

        const startDate:any = formatDateFromIsoToString(new Date().toJSON())

        let currJob: any = [{ 'id': currJobName[0].id, 'name': currJobName[0].name, 'color': currValueColor, 'startDate': startDate }];

        if (jobsList.length > 0 && currJobName[0].name != '') {
            if (jobsList.some((e: any) => e.name === currJobName[0].name) || currJobName.length == 0) {
            } else {
                setJobsList([...jobsList, currJob[0]]);
            }

        } else {
            setJobsList([...jobsList, currJobName]);
        }

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            const params = {
                name: currJob[0].name,
                color: currJob[0].color,
                startDate: currJob[0].startDate
            };
            try {
                await axios.post(`${SERVER_URL}/job`, params, { headers })
                handleChangeJobName({ target: { value: '' } })
                handleChangeColor({ value: '' })
                setLoading(false)

                getJobList(true);
                
                setMessageSavedJob(true);
                if (!messageSavedJob) {
                    setTimeout(() => {
                        setMessageSavedJob(false);
                    }, 3000);
                }
            } catch (error: any) {
                setError(error);
                if (error) {
                    setTimeout(() => {
                        setError(false);
                    }, 3000);
                }
                setLoading(false)
            }
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }
    }
    
    const cloneJob = async (jobInfo: any) => {

        setLoading(true);

        const startDate:any = formatDateFromIsoToString(new Date().toJSON())

        let currJob: any = [{ 'id': jobInfo.id, 'name': jobInfo.name, 'color': jobInfo.color, 'startDate': startDate }];

        if (jobsList.length > 0 && jobInfo.name != '') {
            if (jobsList.some((e: any) => e.name === jobInfo.name) || jobInfo.name.length == 0) {
            } else {
                setJobsList([...jobsList, currJob[0]]);
            }

        } else {
            setJobsList([...jobsList, jobInfo.name]);
        }

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            const params = {
                name: currJob[0].name,
                color: currJob[0].color,
                startDate: currJob[0].startDate
            };
            try {
                await axios.post(`${SERVER_URL}/job`, params, { headers })
                handleChangeJobName({ target: { value: '' } })
                handleChangeColor({ value: '#ffffff' })
                setValueColor('#ffffff')
                setLoading(false)

                getJobList(true);
                
                setMessageClonedJob(true);
                if (!messageClonedJob) {
                    setTimeout(() => {
                        setMessageClonedJob(false);
                    }, 3000);
                }
            } catch (error: any) {
                setError(error);
                if (error) {
                    setTimeout(() => {
                        setError(false);
                    }, 3000);
                }
                setLoading(false)
            }
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }
    }

    const removeNewJob = async (jobId: any, index: any) => {

        setLoading(true);
        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            try {
                await axios.delete(`${SERVER_URL}/job/${jobId}`, { headers }),
                    setJobsList((oldValues: any) => {
                        return oldValues.filter((_: any, i: any) => i !== index)
                    })
                handleChangeJobName({ target: { value: '' } })
                handleChangeColor({ value: '' })
                setLoading(false)
                setMessageDeletedJob(true)
            } catch (error: any) {
                setError(true);
                if (!error) {
                    setTimeout(() => {
                        setError(false);
                    }, 3000);
                }
                setLoading(false)
            }
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }

        if (!messageDeletedJob || !error) {
            setTimeout(() => {
                setMessageDeletedJob(false);
                setError(false);
            }, 3000);
        }
    }

    const refreshJob = () => {
        handleChangeJobName({ target: { value: '' } })
        handleChangeColor({ value: '#ffffff' })
        setValueColor('#ffffff')
        setUpdateJob(false);
        setSelectedJobId(null);
    }

    const bolderStyles = `

        .registry-job-root {
            gap: 12px;
            align-items: stretch;
            padding: 10px;
        }

        .registry-job-left-panel {
            border: 1px solid #d6e8ee;
            border-radius: 14px;
            box-shadow: 0 10px 24px rgba(10, 55, 75, 0.08);
        }

        .registry-job-title {
            font-weight: 800;
            letter-spacing: 0.4px;
            text-shadow: 0 1px 0 rgba(255, 255, 255, 0.7);
        }

        .registry-job-item {
            background: #ffffff;
            border: 1px solid #cfe3ea;
            border-radius: 12px;
            padding: 6px 8px;
            box-shadow: 0 3px 10px rgba(10, 55, 75, 0.06);
            transition: transform 120ms ease, box-shadow 180ms ease;
        }

        .registry-job-item:hover {
            transform: translateY(-1px);
            box-shadow: 0 8px 18px rgba(10, 55, 75, 0.12);
        }

        .registry-job-form-row {
            display: flex;
            margin-bottom: 20px;
            align-items: center;
        }

        .registry-job-label {
            width: 180px;
            align-content: center;
            font-weight: 700;
            color: #0f5f69;
            letter-spacing: 0.2px;
        }

        .registry-job-right {
            border: 1px solid #cfe3ea;
            border-radius: 16px;
            box-shadow: 0 14px 30px rgba(10, 55, 75, 0.1);
            padding: 14px 16px;
        }
    `;

    const normalizedJobSearchValue = jobSearchValue.trim().toLowerCase();
    const filteredJobsList = normalizedJobSearchValue
        ? jobsList.filter((job: any) => {
            const jobName = `${job?.name ?? ''}`.toLowerCase();
            const jobColor = `${job?.color ?? ''}`.toLowerCase();
            const jobId = `${job?.id ?? ''}`.toLowerCase();

            return jobName.includes(normalizedJobSearchValue)
                || jobColor.includes(normalizedJobSearchValue)
                || jobId.includes(normalizedJobSearchValue);
        })
        : jobsList;

    return (
        <div className="flex-parent-element registry-job-root" style={{ overflowX: 'hidden' }}>

            <style>{bolderStyles}</style>

            {loading && loadingPanel}
            <NotificationGroup
                    style={{
                        right: 0,
                        bottom: 0,
                        position: "absolute",
                        alignItems: "flex-start",
                        flexWrap: "wrap-reverse",
                    }}
                >
                    <Fade enter={true} exit={true}>
                        {messageDeletedJob && (
                            <Notification
                                type={{ style: "success", icon: true }}
                                onClose={() => setMessageDeletedJob(false)}
                            >
                                <span>{localizationService.toLanguageString('configuration.registry.job_deleted', 'NOT_FOUND')}</span>
                            </Notification>
                        )}
                        {messageSavedJob && (
                            <Notification
                                type={{ style: "success", icon: true }}
                                onClose={() => setMessageSavedJob(false)}
                            >
                                <span>{localizationService.toLanguageString('configuration.registry.job_saved', 'NOT_FOUND')}</span>
                            </Notification>
                        )}
                        {messageClonedJob && (
                            <Notification
                                type={{ style: "success", icon: true }}
                                onClose={() => setMessageClonedJob(false)}
                            >
                                <span>{localizationService.toLanguageString('configuration.registry.job_cloned', 'NOT_FOUND')}</span>
                            </Notification>
                        )}
                        {messageUpdatedJob && (
                            <Notification
                                type={{ style: "success", icon: true }}
                                onClose={() => setMessageUpdatedJob(false)}
                            >
                                <span>{localizationService.toLanguageString('configuration.registry.job_updated', 'NOT_FOUND')}</span>
                            </Notification>
                        )}
                        {error && (
                            <Notification
                                type={{ style: "error", icon: true }}
                                //closable={true}
                                onClose={() => setMessageSavedJob(false)}
                            >
                                {
                                    errorMessage
                                    ?
                                    <span>{errorMessage}</span>
                                    :
                                    <span>{localizationService.toLanguageString('configuration.registry.job_with_device_error', 'NOT_FOUND')}</span>
                                }
                            </Notification>
                        )}
                    </Fade>
            </NotificationGroup>

            <div
                className="registry-job-left-panel"
                style={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '10px',
                    background: '#F7F7F7',
                    flex: '1.5 1 0px',
                    overflowY: 'hidden',
                }}
            >
                <div style={{ textAlign:'center', marginBottom:'10px' }}>

                    <p className="registry-job-title" style={{ display:'inline-flex', textAlign: 'center', fontSize: '20px', color: '#1A8893', }}>{localizationService.toLanguageString('configuration.registry.jobs', 'NOT_FOUND')} ({filteredJobsList.length})</p>
                    <Button
                        title={localizationService.toLanguageString('configuration.registry.job_new', 'NOT_FOUND')}
                        themeColor={"primary"}
                        className="plusParam"
                        style={{
                            marginRight: '10px',
                            marginTop: '0px',
                            borderRadius: '10px',
                            //boxShadow: '0 3px 10px rgba(26,136,147,0.28)'
                        }}
                        onClick={refreshJob}
                        disabled={userType === 'StandardOnlyLocator'}
                    >
                        <Avatar
                            className="plusParam"
                        >
                            <SvgIcon
                                icon={plusIcon}
                                style={{ margin: '8px' }}
                            />
                        </Avatar>
                    </Button>
                </div>

                <TextBox
                    value={jobSearchValue}
                    onChange={(event: any) => setJobSearchValue(`${event.target.value ?? ''}`)}
                    placeholder={localizationService.toLanguageString('configuration.registry.job_search_placeholder', 'Search job')}
                    style={{ width: '100%', marginBottom: '10px' }}
                />

                <div
                    className="flex-left-child-element"
                    style={{
                        flex: 1,
                        minHeight: 0,
                        padding: '8px',
                        overflowY: 'auto',
                        width: '100%',
                    }}
                >
                    {filteredJobsList?.map((job: any, index: any) => {
                        const originalIndex = jobsList.findIndex((item: any) => item?.id === job?.id);
                        const indexToRemove = originalIndex !== -1 ? originalIndex : index;
                        return (
                            job.id != -1 &&
                            <div
                                key={index}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    marginBottom: '6px'
                                }}
                            >

                                <div
                                    className="trash-icon"
                                    title={localizationService.toLanguageString('configuration.registry.job_delete', 'NOT_FOUND')} 
                                    style={{
                                        float: 'left',
                                        cursor: 'pointer',
                                        alignContent: 'center',
                                        pointerEvents: `${userType === 'StandardOnlyLocator' ? 'none' : 'auto'}`,
                                        opacity: `${userType === 'StandardOnlyLocator' ? 0.5 : 1}`
                                    }}
                                    onClick={() => {
                                        setUpdateJob(false)
                                        removeNewJob(job.id, indexToRemove)
                                    }}
                                >
                                    <Avatar 
                                        className="trash-icon"
                                    >
                                        <SvgIcon 
                                            icon={trashIcon} 
                                            style={{ verticalAlign: 'baseline', margin: '10px' }} 
                                        />
                                    </Avatar>
                                </div>

                                <div
                                    className="trash-icon"
                                    style={{
                                        float: 'left',
                                        cursor: `${userType === 'StandardOnlyLocator' ? 'default' : 'pointer'}`,
                                        alignContent: 'center',
                                        marginRight: '10px',
                                        pointerEvents: `${userType === 'StandardOnlyLocator' ? 'none' : 'auto'}`,
                                        opacity: `${userType === 'StandardOnlyLocator' ? 0.5 : 1}`
                                    }}
                                    onClick={() => {
                                        setUpdateJob(false)
                                        cloneJob(job)
                                    }}                                     
                                    title={localizationService.toLanguageString('configuration.registry.job_clone', 'NOT_FOUND')}
                                >
                                    <Avatar 
                                        className="trash-icon"
                                    >
                                        <SvgIcon 
                                            icon={copyIcon} 
                                            style={{ verticalAlign: 'baseline', margin: '10px' }} 
                                        />
                                    </Avatar>
                                </div> 


                                <div
                                    style={{ display: 'inline-flex', alignItems: 'center', flex: 1 }}
                                    onClick={() => getSelectedJob(job)}
                                >
                                    <p 
                                        style={{ 
                                            border: `1px solid ${ (job?.color == '#ffffff' || job?.color == '#NaN') ? 'black' : job?.color}`, 
                                            borderRadius: '30px', 
                                            width: '18px', 
                                            height: '18px', 
                                            marginTop: '10px', 
                                            background: `${job?.color}` 
                                        }}
                                    ></p>
                                    <p
                                        className={`card-block-registry-group registry-job-item${selectedJobId === job.id ? ' is-selected' : ''}`}
                                        style={{
                                            cursor: 'pointer',
                                            marginLeft: '10px',
                                            marginBottom: '0px',
                                            padding: '10px',
                                            flex: 1,
                                            color: selectedJobId === job.id ? '#ffffff' : 'inherit',
                                            background: selectedJobId === job.id ? '#198792' : '#ffffff',
                                            fontSize: 'clamp(11px, 0.7vw, 16px)'
                                        }}
                                    >
                                        {`${job?.id ?? ''}  : ${job?.name}`}
                                    </p>
                                </div>
                            </div>
                        )
                    })}
                </div>

            </div>

            
            <div 
                className="flex-right-child-element registry-job-right" 
                style={{
                    background: 'white',
                }}
            >
                
                <div>
                    <div className="registry-job-form-row">
                        {/*name*/}
                        <div className="registry-job-label">
                            {localizationService.toLanguageString('configuration.registry.job_name', 'NOT_FOUND')}
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <span
                                className="k-icon k-font-icon k-i-palette"
                                style={{
                                    width: '0px',
                                    height: '0px',
                                    fontSize: 'x-large',
                                    cursor: 'pointer',
                                    background: `${valueColor}`,
                                    border: '1px solid #bdc4cb',
                                    borderRadius: '30px',
                                    padding: '20px',
                                    pointerEvents: `${userType === 'StandardOnlyLocator' ? 'none' : 'auto'}`,
                                    opacity: `${userType === 'StandardOnlyLocator' ? 0.5 : 1}`
                                }}
                                onClick={showColorPicker}
                            />

                            <TextBox
                                style={{ width: "350px" }}
                                value={jobName == '' ? jobName : jobInfo?.map((job: any) => {
                                    return job.name
                                })}
                                onChange={handleChangeJobName}
                                placeholder=''
                                disabled={userType === 'StandardOnlyLocator'}
                            />

                            {/*save / update*/}
                            {!updateJob ?
                                <Button
                                    title={localizationService.toLanguageString('configuration.registry.job_save', 'NOT_FOUND')}
                                    themeColor={"primary"}
                                    className="saveParam"
                                    disabled={jobName == '' ? true : false || userType === 'StandardOnlyLocator'}
                                    onClick={() => saveNewJob(jobInfo, valueColor)}
                                >
                                    <Avatar
                                        className="saveParam"
                                    >
                                        <SvgIcon
                                            icon={saveIcon}
                                            style={{ margin: '8px' }}
                                        />
                                    </Avatar>
                                </Button>
                                :
                                <div>
                                    <Button
                                        title={localizationService.toLanguageString('configuration.registry.job_update', 'NOT_FOUND')}
                                        themeColor={"primary"}
                                        className="saveParam"
                                        onClick={() => updateSelectedJob(jobInfo[0].id, jobInfo[0].name, valueColor == jobInfo[0].color ? jobInfo[0].color : valueColor)}
                                        disabled={userType === 'StandardOnlyLocator'}
                                    >
                                        <Avatar
                                            className="saveParam"
                                        >
                                            <SvgIcon
                                                icon={saveIcon}
                                                style={{ margin: '8px' }}
                                            />
                                        </Avatar>
                                    </Button>
                                </div>
                            }
                        </div>
                    </div>

                    {/*colorpicker*/}
                    {
                        toggleColorPicker &&
                            <Dialog
                                className="no-padding-dialog"
                                onClose={() => setToggleColorPicker(false)}
                            >
                                <FlatColorPicker
                                    value={valueColor}
                                    format="hex"
                                    onChange={handleChangeColor}
                                />
                            </Dialog>
                    }
                </div>

            </div>
        </div>
    );


};
